import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { IWellSummaryModel } from "../../../services/summary-listing-data-service/WellSummaryModels";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseWellSummaryDataParameters = {
    customerID: number,
    groupID: number,
    configurationID?: number;
} & BaseUseQueryParameters<IWellSummaryModel>;

export function useWellSummaryData({
    customerID,
    groupID,
    configurationID,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseWellSummaryDataParameters) {
    return useQuery<IWellSummaryModel, RestError>(
        keys.summaryData(customerID, groupID, offline ?? false, configurationID),
        ({ signal }) => {
            return SummaryListingDataService.getWellData(customerID, groupID, configurationID ?? 0, "", offline ?? false, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
